import FullscreenLoader from "@/components/fullscreen-loader";
import Signin from "@/pages/signin";
import { createFileRoute, Navigate, useSearch } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/signin")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Signin />;
}
